import { Crown } from "lucide-react";
import { lei, packTotals } from "@/lib/pricing";
import { waLink } from "@/lib/wa";
import { WhatsAppGlyph } from "@/components/cards/CardShell";

const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

const ROWS = [
  ["Investiție", (t) => lei(t.price)],
  ["Discount", (t, pk) => `-${pk.discount}%`],
  ["Bucăți", (t) => t.pieces],
  ["Cadouri", (t) => (t.giftPieces ? `${t.giftPieces} buc.` : "—")],
  ["Tratamente", (t) => t.treatments],
  ["Încasări", (t) => lei(t.revenue)],
  ["Profit", (t) => lei(t.profit), "is-profit"],
  ["Randament", (t) => `${pct(t.profit, t.price)}%`, "is-profit"],
];

export default function PackCompare({ data, track }) {
  const cols = data.packages.map((pk) => ({ pk, t: packTotals(pk, data) }));
  const best = cols.reduce((b, c) => (c.t.profit > b.t.profit ? c : b), cols[0])?.pk.id;
  return (
    <div className="cmp-wrap" data-testid="pack-compare">
      <table className="cmp-table">
        <thead>
          <tr>
            <th />
            {cols.map(({ pk }) => (
              <th key={pk.id} className={pk.id === best ? "is-best" : ""} data-testid={`compare-head-${pk.id}`}>
                {pk.id === best && <span className="cmp-badge" data-testid="compare-best-badge"><Crown size={10} /> Top profit</span>}
                {pk.name.replace("Pachet ", "")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([label, fn, cls]) => (
            <tr key={label} className={cls || ""}>
              <th>{label}</th>
              {cols.map(({ pk, t }) => <td key={pk.id} className={pk.id === best ? "is-best" : ""} data-testid={`compare-${label.toLowerCase()}-${pk.id}`}>{fn(t, pk)}</td>)}
            </tr>
          ))}
          <tr className="cmp-actions">
            <th />
            {cols.map(({ pk, t }) => {
              const wa = waLink(data.contact.whatsapp, `Bună ziua, aș dori să comand ${pk.name} (-${pk.discount}%) · ${lei(t.price)} (TVA inclus).`);
              return (
                <td key={pk.id} className={pk.id === best ? "is-best" : ""}>
                  {wa && (
                    <a className="cmp-order" href={wa} target="_blank" rel="noopener noreferrer" onClick={() => track?.("order", pk.id, pk.items)} data-testid={`compare-order-${pk.id}`}>
                      <WhatsAppGlyph /> Comandă
                    </a>
                  )}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      <p className="pf-note">Toate sumele includ TVA. Tratamente la {lei(data.service_price)}/serviciu.</p>
    </div>
  );
}
